export default class Entrada {
  constructor(idFornecedor = "", dataCompra = "", dataEntrada = "", produtos = []) {
    this.IdFornecedor = idFornecedor
    this.DataCompra = dataCompra
    this.DataEntrada = dataEntrada
    this.Produtos = produtos
  }
}
